import { useState } from 'react';
import { C } from '../styles/colours.js';
import { PRICES } from '../stripe.js';
import { supabase } from '../supabase.js';

function Pricing({ onClose, onSelect }) {
  const [loading, setLoading] = useState(null);

  const handlePay = async (planId) => {
    if (planId === 'business') {
      window.location.href = 'mailto:hello@tabliq.io?subject=Business Plan Enquiry';
      return;
    }
    setLoading(planId);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const userEmail = session?.user?.email || '';

      const res = await fetch('https://tabliq-server-production.up.railway.app/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ priceId: PRICES[planId], planId, userEmail }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Something went wrong. Please try again.');
        setLoading(null);
      }
    } catch (err) {
      alert('Payment error. Please try again.');
      setLoading(null);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(7,7,26,0.98)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 999, padding: '20px', fontFamily: 'sans-serif', overflowY: 'auto' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        {/* Close */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <button onClick={onClose} style={{ background: C.card, border: 'none', color: C.textSub, padding: '8px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>✕ Close</button>
        </div>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 64, height: 64, borderRadius: 16, background: 'linear-gradient(145deg, #e8526a, #c0392b)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 26, margin: '0 auto 14px', color: '#fff' }}>TQ</div>
          <div style={{ fontSize: 22, fontWeight: 900, color: C.white, marginBottom: 6 }}>Upgrade TabliQ</div>
          <div style={{ fontSize: 13, color: C.textSub, lineHeight: 1.6 }}>You've used your free game.<br/>Pick a plan to keep hosting.</div>
        </div>

        {/* Day Pass */}
        <div onClick={() => !loading && handlePay('day')} style={{ background: C.card, border: `2px solid ${C.green}50`, borderRadius: 16, padding: '16px 18px', marginBottom: 10, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 14, opacity: loading && loading !== 'day' ? 0.5 : 1 }}>
          <div style={{ width: 46, height: 46, borderRadius: 12, background: `${C.green}15`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ fontSize: 18, fontWeight: 900, color: C.green, lineHeight: 1 }}>£0</div>
            <div style={{ fontSize: 9, color: C.green, fontWeight: 700 }}>.99</div>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 800, color: C.white }}>Day Pass</div>
            <div style={{ fontSize: 13, color: C.textSub, marginTop: 2 }}>One session · Up to 6 players</div>
          </div>
          <div style={{ fontSize: 11, color: C.green, fontWeight: 700, background: `${C.green}15`, padding: '4px 10px', borderRadius: 20 }}>
            {loading === 'day' ? '...' : 'Today only'}
          </div>
        </div>

        {/* Monthly */}
        <div onClick={() => !loading && handlePay('month')} style={{ background: C.card, border: `2px solid ${C.gold}70`, borderRadius: 16, padding: '16px 18px', marginBottom: 10, cursor: 'pointer', position: 'relative', overflow: 'hidden', opacity: loading && loading !== 'month' ? 0.5 : 1 }}>
          <div style={{ position: 'absolute', top: 0, right: 0, background: C.gold, color: '#000', fontSize: 9, fontWeight: 900, padding: '4px 12px', borderBottomLeftRadius: 10 }}>🔥 MOST POPULAR</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ width: 46, height: 46, borderRadius: 12, background: `${C.gold}15`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ fontSize: 18, fontWeight: 900, color: C.gold, lineHeight: 1 }}>£3</div>
              <div style={{ fontSize: 9, color: C.gold, fontWeight: 700 }}>.99</div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: C.white }}>Monthly</div>
              <div style={{ fontSize: 13, color: C.textSub, marginTop: 2 }}>Unlimited sessions · Up to 6 players</div>
            </div>
            <div style={{ fontSize: 11, color: C.gold, fontWeight: 700 }}>
              {loading === 'month' ? '...' : '/ month'}
            </div>
          </div>
        </div>

        {/* Yearly */}
        <div onClick={() => !loading && handlePay('year')} style={{ background: C.card, border: `2px solid ${C.purple}50`, borderRadius: 16, padding: '16px 18px', marginBottom: 10, cursor: 'pointer', position: 'relative', overflow: 'hidden', opacity: loading && loading !== 'year' ? 0.5 : 1 }}>
          <div style={{ position: 'absolute', top: 0, right: 0, background: C.purple, color: '#fff', fontSize: 9, fontWeight: 900, padding: '4px 12px', borderBottomLeftRadius: 10 }}>💰 SAVE 50%</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ width: 46, height: 46, borderRadius: 12, background: `${C.purple}15`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ fontSize: 16, fontWeight: 900, color: C.purple, lineHeight: 1 }}>£24</div>
              <div style={{ fontSize: 9, color: C.purple, fontWeight: 700 }}>.99</div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: C.white }}>Yearly</div>
              <div style={{ fontSize: 13, color: C.textSub, marginTop: 2 }}>Unlimited sessions · Up to 6 players</div>
            </div>
            <div style={{ fontSize: 11, color: C.purple, fontWeight: 700 }}>
              {loading === 'year' ? '...' : '/ year'}
            </div>
          </div>
        </div>

        {/* Business */}
        <div onClick={() => handlePay('business')} style={{ background: 'linear-gradient(135deg, rgba(17,138,178,0.15), rgba(17,138,178,0.05))', border: `1px solid ${C.blue}40`, borderRadius: 16, padding: '16px 18px', marginBottom: 20, cursor: 'pointer' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ fontSize: 28 }}>🏨</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: C.white }}>Hotel & Business</div>
              <div style={{ fontSize: 13, color: C.textSub, marginTop: 2 }}>From £29.99/month · Unlimited players</div>
            </div>
            <div style={{ fontSize: 12, fontWeight: 700, color: C.blue, background: `${C.blue}15`, padding: '6px 12px', borderRadius: 20 }}>Contact →</div>
          </div>
        </div>

        {/* Trust line: cancel anytime + refund policy */}
        <div style={{ textAlign: 'center', fontSize: 12, color: C.textMuted, marginBottom: 14 }}>
          Cancel anytime ·{' '}
          <a href="/refunds.html" target="_blank" rel="noopener noreferrer" style={{ color: C.textSub, fontWeight: 700, textDecoration: 'underline' }}>Refund policy</a>
        </div>

        {/* Maybe later */}
        <div style={{ textAlign: 'center' }}>
          <div onClick={onClose} style={{ fontSize: 13, color: C.textMuted, cursor: 'pointer', textDecoration: 'underline' }}>
            Maybe later
          </div>
        </div>

      </div>
    </div>
  );
}

export default Pricing;
